import {
  compressToEncodedURIComponent,
  decompressFromEncodedURIComponent,
} from 'lz-string';

/**
 * Compress an arbitrary filter-state object into a single URL-safe string.
 *
 * Used to persist a page's filter selections in one query param (e.g. `?f=...`)
 * instead of one param per filter. lz-string keeps even large selections
 * (hundreds of numeric IDs) to a few hundred URL-safe characters.
 */
export const encodeFilterState = (state: Record<string, unknown>): string =>
  compressToEncodedURIComponent(JSON.stringify(state));

/**
 * Reverse of {@link encodeFilterState}. Returns `null` for empty, malformed, or
 * outdated values so callers can safely fall back to defaults without crashing.
 */
export const decodeFilterState = <T>(raw: string | null | undefined): T | null => {
  if (!raw) {
    return null;
  }

  try {
    const json = decompressFromEncodedURIComponent(raw);
    if (!json) {
      return null;
    }

    return JSON.parse(json) as T;
  } catch {
    return null;
  }
};
